import { McpEntity } from '@/lib/models/policy-model/mcp-controls';

export const buildToolAccess = (
  current: McpEntity[] | undefined,
  selectedIds: string[],
  action: 'allow' | 'block'
): McpEntity[] => {
  const alternateAction = action === 'allow' ? 'block' : 'allow';
  const alternateEntities = (current ?? []).filter((entity) => entity.action === alternateAction);
  const ourEntities: McpEntity[] = selectedIds.map((toolId) => ({ toolId, action }));
  return [...alternateEntities, ...ourEntities];
};
